import React from "react";

const GoogleDocsIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.9242 18.3333H5.07569C4.45069 18.3333 3.93933 17.822 3.93933 17.197V2.80303C3.93933 2.17803 4.45069 1.66667 5.07569 1.66667H11.8939L16.0605 5.83333V17.197C16.0605 17.822 15.5492 18.3333 14.9242 18.3333Z",
  fill: "#3086F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.8939 1.66667L16.0606 5.83333H11.8939V1.66667Z",
  fill: "#0C67D6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.409 9.05306H6.59082V8.10609H13.409V9.05306ZM13.409 10.3788H6.59082V11.3258H13.409V10.3788ZM11.5151 12.6515H6.59082V13.5985H11.5151V12.6515Z",
  fill: "#FDFFFF"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(GoogleDocsIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;